<template>
                <div v-if="currentView === 'users'">
                    <div class="page-header">
                        <div><div class="page-title">使用者管理</div><div class="page-subtitle">管理郵件帳號、密碼、配額與角色</div></div>
                    </div>
                    <div class="card p-6 mb-6">
                        <h3 class="card-title mb-3">新增使用者</h3>
                        <form @submit.prevent="addUser">
                        <div class="grid grid-cols-1 md:grid-cols-8 gap-2 items-end">
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">使用者名稱</label>
                                <input v-model="newUser.username" type="text" placeholder="bob"
                                    class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">密碼</label>
                                <input v-model="newUser.password" type="password" placeholder="密碼"
                                    class="input" autocomplete="new-password">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">網域</label>
                                <select v-model="newUser.domain_id" @change="fetchDepartments(newUser.domain_id)" class="input">
                                    <option v-for="(d, idx) in safeArr(domains)" :key="keyById(d, 'domain-opt', idx)" :value="d.id">{{ d.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">角色</label>
                                <select v-model="newUser.role" class="input">
                                    <option value="user">一般使用者</option>
                                    <option value="domain_admin" v-if="isSuperAdmin">網域管理員</option>
                                    <option value="super_admin" v-if="isSuperAdmin">超級管理員</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">配額 (MB)</label>
                                <input v-model="newUser.quota" type="number" class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">公司名稱</label>
                                <input v-model="newUser.company_name" type="text" placeholder="公司"
                                    class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">部門</label>
                                <select v-model="newUser.department_id" class="input">
                                    <option :value="null">未指定</option>
                                    <option v-for="(dept, idx) in safeArr(departments)" :key="keyById(dept, 'dept', idx)" :value="dept.id">{{ dept.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">電話分機</label>
                                <input v-model="newUser.phone_ext" type="text" placeholder="分機"
                                    class="input">
                            </div>
                            <button type="submit"
                                class="btn btn-primary mb-0.5">建立</button>
                        </div>
                        </form>
                    </div>
                    <div class="card p-6">
                        <table class="data-table">
                            <thead>
                                <tr class="border-b">
                                    <th class="p-2">ID</th>
                                    <th class="p-2">Email</th>
                                    <th class="p-2">公司</th>
                                    <th class="p-2">部門</th>
                                    <th class="p-2">分機</th>
                                    <th class="p-2">角色</th>
                                    <th class="p-2">配額</th>
                                    <th class="p-2">狀態</th>
                                    <th class="p-2">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, idx) in safeArr(users)" :key="keyById(user, 'user', idx)" class="border-b">
                                    <td class="p-2">{{ user.id }}</td>
                                    <td class="p-2">{{ user.email }}</td>
                                    <td class="p-2">{{ user.company_name || '-' }}</td>
                                    <td class="p-2">{{ user.department_name || '-' }}</td>
                                    <td class="p-2">{{ user.phone_ext || '-' }}</td>
                                    <td class="p-2">
                                        <span v-if="user.role === 'super_admin'"
                                            class="text-xs px-2 py-1 rounded" style="background:var(--purple-100,#ede9fe);color:var(--purple-800,#5b21b6);">超級管理員</span>
                                        <span v-else-if="user.role === 'domain_admin'"
                                            class="text-xs px-2 py-1 rounded" style="background:var(--blue-100,#dbeafe);color:var(--blue-800,#1e40af);">網域管理員</span>
                                        <span v-else
                                            class="btn btn-secondary btn-xs">使用者</span>
                                    </td>
                                    <td class="p-2">{{ user.quota ? (user.quota / 1024 / 1024).toFixed(0) + ' MB' : '0'
                                        }}</td>
                                    <td class="p-2">
                                        <span v-if="user.active" style="color:var(--success);">✔</span>
                                        <span v-else style="color:var(--danger);">✘</span>
                                    </td>
                                    <td class="p-2">
                                        <button @click="startEditUser(user)"
                                            class="text-sm mr-2" style="color:var(--primary);">編輯</button>
                                        <button @click="deleteUser(user.id)" class="btn btn-ghost btn-xs" style="color:var(--color-danger)">刪除</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Edit User Modal -->
                <div v-if="editingUser" class="fixed inset-0 flex items-center justify-center" style="background:rgba(0,0,0,0.5);">
                    <div class="card p-6 w-96">
                        <h3 class="card-title mb-4">編輯使用者</h3>
                        <form @submit.prevent="updateUser" class="space-y-4">
                            <div>
                                <label class="block text-sm">使用者名稱</label>
                                <input v-model="editUserForm.username" type="text" class="w-full border p-2 rounded"
                                    :disabled="!isSuperAdmin && (Number(editingUser?.id) || 0) !== (Number(currentUser?.id) || 0)">
                            </div>
                            <div>
                                <label class="block text-sm">網域</label>
                                <select v-model="editUserForm.domain_id" @change="fetchDepartments(editUserForm.domain_id)" class="w-full border p-2 rounded"
                                    :disabled="!isSuperAdmin">
                                    <option v-for="(d, idx) in safeArr(domains)" :key="keyById(d, 'domain-opt2', idx)" :value="d.id">{{ d.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm">角色</label>
                                <select v-model="editUserForm.role" class="w-full border p-2 rounded"
                                    :disabled="!isSuperAdmin">
                                    <option value="user">一般使用者</option>
                                    <option value="domain_admin">網域管理員</option>
                                    <option value="super_admin">超級管理員</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm">公司名稱</label>
                                <input v-model="editUserForm.company_name" type="text" class="w-full border p-2 rounded">
                            </div>
                            <div>
                                <label class="block text-sm">部門</label>
                                <select v-model="editUserForm.department_id" class="w-full border p-2 rounded">
                                    <option :value="null">未指定</option>
                                    <option v-for="(dept, idx) in safeArr(departments)" :key="keyById(dept, 'dept2', idx)" :value="dept.id">{{ dept.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm">電話分機</label>
                                <input v-model="editUserForm.phone_ext" type="text" class="w-full border p-2 rounded">
                            </div>
                            <div>
                                <label class="block text-sm">新密碼 (留空則不修改)</label>
                                <input v-model="editUserForm.password" type="password"
                                    class="w-full border p-2 rounded" autocomplete="new-password">
                            </div>
                            <div>
                                <label class="block text-sm">配額</label>
                                <input v-model="editUserForm.quota" type="number" class="w-full border p-2 rounded"
                                    :disabled="!isSuperAdmin && !isDomainAdmin">
                            </div>
                            <div class="flex items-center">
                                <input v-model="editUserForm.active" type="checkbox" class="mr-2"
                                    :disabled="!isSuperAdmin && !isDomainAdmin">
                                <label class="text-sm">啟用</label>
                            </div>
                            <div class="flex justify-end gap-2">
                                <button type="button" @click="editingUser = null" class="px-4 py-2 border rounded">取消</button>
                                <button type="submit" class="btn btn-primary">儲存</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Departments View -->

</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()

// Spread all store state as reactive refs accessible in template
const stateRefs = storeToRefs(store)
// Destructure - Vue compiler exposes all variables declared in <script setup> to template
const {
  // Core state
  token, currentView, currentUser, loginForm, loginError,
  branding, notifications, showNotifPanel,
  // Command palette
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  // Domain / Users / Departments
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  // Contacts / Groups
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  // Mail
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  // Invoice Drive
  invoiceDriveState,
  // Quotes / Products
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  // SSL
  sslCerts, sslLoading, sslDomain,
  // Security
  securityWizardStep, spamStats,
  securityFilterState,
  // Server settings
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  // Logs / Audit
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  // AI / RAG / Sales
  ragState, aiSalesState, aiMarketingState,
  // LINE
  lineSupportState,
  // Webmail
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  // Unreplied
  unrepliedEmails, unrepliedLoading,
  // CBI
  cbiInsights, cbiLoading,
  // Misc
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
  newUser, isSuperAdmin, isDomainAdmin,
  editingUser, editUserForm,
} = stateRefs

// Methods are accessed directly from store (not reactive, no storeToRefs needed)
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
  addUser, startEditUser, updateUser,
} = store
</script>

